export const SSO_POPUP_FLAG = "sso_popup_flow";
export const SSO_CHANNEL = "sso_google_result";
export const SSO_FLAG_TTL_MS = 10 * 60 * 1000;

// True when the current window is the SSO popup we opened from the parent.
// Reads-and-clears the flag so stale flags can't mis-route a future visit.
export const consumeSSOPopupFlag = () => {
  const flagRaw = localStorage.getItem(SSO_POPUP_FLAG);
  const flagTime = flagRaw ? Number(flagRaw) : 0;
  const inPopup = flagTime > 0 && Date.now() - flagTime < SSO_FLAG_TTL_MS;
  localStorage.removeItem(SSO_POPUP_FLAG);
  return inPopup;
};

export const broadcastSSOResultAndClose = (error) => {
  const channel = new BroadcastChannel(SSO_CHANNEL);
  channel.postMessage({
    type: "SSO_RESULT",
    ok: !error,
    error: error ? decodeURIComponent(error) : null,
  });
  channel.close();
  window.close();
};
